export default __webpack_public_path__ + "static/media/docs.e79c73c3.svg";